
import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";


import Home from "../components/Home";
// const Home = lazy(() => import("../pages/Home/Home"));
// const Projects = lazy(() => import("../pages/Projects/Projects"));
// const Categories = lazy(() => import("../pages/Categories/Categories"));
// const About = lazy(() => import("../pages/About/About"));
// const Contact = lazy(() => import("../pages/Contact/Contact"));

export default function AppRoutes() {
  return (
    <Suspense
      fallback={
        <div className="text-center py-5">
          Loading...
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/projects" element={<Projects />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} /> */}
      </Routes>
    </Suspense>
  );
}

